module.exports = __webpack_public_path__ + "static/img/illu_en_04.3ae4ad9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illus/illu_en_04.png
// module id = AbMi
// module chunks = 1